var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.832,
    y1: 0.133,
    x2: -0.053,
    y2: 1.041,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd71ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b8e8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3130",
    "data-name": "Rectangle 3130",
    width: 32,
    height: 32,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13693",
    "data-name": "Group 13693",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(12 12)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13711",
    "data-name": "Group 13711",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13710",
    "data-name": "Group 13710",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13077",
    "data-name": "Path 13077",
    d: "M13.46,20.343c.085-.258.169-.5.247-.749a2.084,2.084,0,0,0-.623-2.292,2.013,2.013,0,0,0-2.278-.39c-.4.163-.77.379-1.2.594a37.483,37.483,0,0,1,.216-5.842H22.144a35.28,35.28,0,0,1,.041,8.679Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13078",
    "data-name": "Path 13078",
    d: "M21.987,10.17H10.02c.122-.672.235-1.317.358-1.96a46.969,46.969,0,0,1,2.367-7.7.477.477,0,0,1,.317-.234A15.753,15.753,0,0,1,17.608.081c.44.043.877.118,1.316.178a.4.4,0,0,1,.361.292A51,51,0,0,1,21.76,8.824c.082.433.147.869.227,1.346",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13079",
    "data-name": "Path 13079",
    d: "M22.016,21.844c-.2.989-.388,1.956-.6,2.918A58.353,58.353,0,0,1,19.471,31a1.067,1.067,0,0,1-1.02.844,17.7,17.7,0,0,1-5.26-.075.6.6,0,0,1-.553-.475c-.442-1.407-.92-2.8-1.371-4.207a.877.877,0,0,1-.006-.517c.512-1.492,1.044-2.977,1.562-4.466a.345.345,0,0,1,.38-.286c2.83.009,5.659.006,8.489.007.088,0,.177.012.324.023",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13080",
    "data-name": "Path 13080",
    d: "M7.265,31.993c-.374-.006-.6-.2-.729-.638-.4-1.386-.8-2.769-1.176-4.16a.681.681,0,0,0-.544-.547c-1.379-.375-2.751-.779-4.127-1.165a.793.793,0,0,1-.679-.667c-.046-.333.112-.582.516-.8q5.187-2.753,10.376-5.5c.13-.069.269-.124.4-.2a.619.619,0,0,1,.812.05.75.75,0,0,1,.183.872c-.383,1.068-.757,2.139-1.134,3.209l-3.138,8.89c-.169.482-.375.657-.756.651",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13081",
    "data-name": "Path 13081",
    d: "M23.647,11.656H31.4a16.122,16.122,0,0,1,0,8.7H23.67a39.691,39.691,0,0,0-.023-8.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13082",
    "data-name": "Path 13082",
    d: "M8.354,11.653a39.813,39.813,0,0,0-.188,6.4.337.337,0,0,1-.223.363c-1.164.613-2.324,1.235-3.486,1.852a.6.6,0,0,1-.251.094c-1.191.006-2.382,0-3.589,0a15.819,15.819,0,0,1-.01-8.715Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13083",
    "data-name": "Path 13083",
    d: "M30.865,10.189h-.4c-2.192,0-4.385-.006-6.577.007-.316,0-.439-.063-.491-.4a41.558,41.558,0,0,0-2.361-8.65c-.039-.1-.074-.207-.115-.318,3.434.449,9.006,5.685,9.943,9.366",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13084",
    "data-name": "Path 13084",
    d: "M21.012,31.181c.584-1.887,1.21-3.771,1.741-5.682.308-1.111.467-2.265.682-3.4.034-.18.069-.283.287-.283,2.341.008,4.681.006,7.021.008a.9.9,0,0,1,.144.031,15.779,15.779,0,0,1-3.146,5.015c-1.876,2.024-4.877,3.932-6.729,4.312",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13085",
    "data-name": "Path 13085",
    d: "M11.055.828c-.343.986-.7,1.963-1.023,2.95A32.616,32.616,0,0,0,8.563,9.925c-.021.167-.062.267-.265.267q-3.527-.01-7.053-.008a.328.328,0,0,1-.089-.028c.667-3.408,6.406-8.817,9.9-9.328",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13086",
    "data-name": "Path 13086",
    d: "M10.366,29.088c.252.743.477,1.407.728,2.149l-1.317-.49.589-1.659",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.16caf88645aaa8f3d7fba57464f589ad.svg";
export { ForwardRef as ReactComponent };